import { Institution } from '@lemsar/institution/domains/model/institution';
import { BuildingType } from '@lemsar/common/domains/models/building-type';
import { SubVocational } from '@lemsar/common/domains/models/sub-vocational';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    22/06/2018
 */
export class Building {
    public id: string;
    public total: number;
    public capacity: number;
    public area: number;
    public status: string;
    public condition: string;
    public buildingType: BuildingType;
    public institution: Institution;
}

export class VocationalBuilding {
    public id: string;
    public total: number;
    public capacity: number;
    public area: number;
    public status: string;
    public condition: string;
    public buildingType: BuildingType;
    public institution: Institution;
    public buildingable: {
        id: string;
        subVocational: SubVocational;
    };
}

export class BuildingGallery {
    public Id: string;
    public description: string;
    public createdAt: string;
    public bigImage: string;
    public medImage: string;
    public smImage: string;
}

export class UploadBuildingGallery {
    public image: File;
    public description: string;
}

export class UploadLogo {
    public logo: File;
}

export class EquipmentBuilding {
    public id: string;
    public building: Building | VocationalBuilding;
    public name: string;
    public total: number;
    public condition: string;
    public description: string;
    public pictures?: EquipmentGallery;
}

export class EquipmentGallery {
    public Id: string;
    public description: string;
    public createdAt: string;
    public bigImage: string;
    public medImage: string;
    public smImage: string;
}

export class UploadEquipmentGallery {
    public image: File;
    public description: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/building.ts